import { Button } from '@/core/ui/atoms/button'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { useDisclosure } from '@heroui/react'
import { useTranslations } from 'next-intl'
import { useReservationStore } from '../../store'
import { BookForm } from '../book-form'

export const EditOrder = ({ className }: { className: string }) => {
  const t = useTranslations()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const bookForm = useReservationStore(state => state.bookForm)
  return (
    <>
      <span className={className}>
        <Button
          className={`h-7 rounded-3xl px-4 py-1 text-white ltr:right-0 rtl:left-0`}
          color='sky-blue'
          onClick={onOpen}
        >
          {t('actions.edit')}
        </Button>
      </span>

      <Modal isOpen={isOpen} onClose={onClose} disableBackdropDismiss>
        <ModalBody>
          <BookForm
            title={t('trip.editBooking')}
            className='max-h-screen overflow-y-auto p-5'
            onSuccess={onClose}
            initialValues={bookForm}
            actions={{
              submit: isLoading => (
                <Button
                  type='submit'
                  loading={isLoading}
                  className='h-11 w-full px-5'
                >
                  {t('actions.update')}
                </Button>
              ),
              cancel: isLoading => (
                <Button
                  onClick={onClose}
                  type='button'
                  color='sky-blue'
                  variant='outlined'
                  className='h-11 w-full px-5'
                  disabled={isLoading}
                >
                  {t('actions.cancel')}
                </Button>
              ),
            }}
          />
        </ModalBody>
      </Modal>
    </>
  )
}
